import { render } from "./ViewPresentationJourneyDemo.vue?vue&type=template&id=2d9d2055&scoped=true"
import script from "./ViewPresentationJourneyDemo.vue?vue&type=script&lang=js"
export * from "./ViewPresentationJourneyDemo.vue?vue&type=script&lang=js"

import "./ViewPresentationJourneyDemo.vue?vue&type=style&index=0&id=2d9d2055&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9d2055"]])

export default __exports__